import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Initialize i18next only if it's not already initialized
if (!i18n.isInitialized) {
  i18n
    // Load translation files via HTTP
    .use(HttpBackend)
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
      // Fallback language
      fallbackLng: 'en',

      // Let language detector determine the language (don't force default)
      lng: undefined,

      // Debug mode (disabled to reduce console noise)
      debug: false,

      // Backend options
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },

      // Interpolation options
      interpolation: {
        escapeValue: false, // React already does escaping
      },

      // Language detection options
      detection: {
        // Order and from where user language should be detected
        order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],

        // Keys or params to lookup language from
        lookupLocalStorage: 'i18nextLng',
        lookupCookie: 'i18nextLng',

        // Cache user language on
        caches: ['localStorage', 'cookie'],

        // Optional expire and domain for set cookie
        cookieMinutes: 10080, // 7 days
        cookieDomain: window.location.hostname,
      },

      // Namespaces
      ns: ['common', 'production', 'products', 'sales', 'customers', 'procurement', 'admin', 'operator', 'supervisor', 'warehouse', 'qc'],
      defaultNS: 'common',

      // Only load base language (e.g., 'en' instead of 'en-GB')
      load: 'languageOnly',

      // React specific options
      react: {
        useSuspense: false, // Disable suspense for SSR compatibility
      },

      // Preload languages and namespaces
      preload: ['en', 'es'],

      // Wait for all namespaces to load before resolving
      initImmediate: false
    });
}

export default i18n;